import { Expose, Type } from 'class-transformer';
import { Media } from '../../shared-features/models/media.model';
import { InsuranceModel } from './insurance-model.model';
import { LocationModel } from '../../customers/models/location.model';
import { User } from '../../users/models/user.model';
import { Status } from '../../shared-features/enums/shared-enums.enum';
import { DropdownModel } from '@shared/models/dropdown-model.model';
import { FleetType } from '../../shared-features/enums/fleets.enum';
import { Customer } from '../../customers/models/customer.model';
import { AthrOperationCard } from './athr-card-model';
import { VendorSource } from '@shared-features/enums/vendor-source.enum';
import { FleetClassificationSource } from '../enums/fleet-classification-source.enum';

export class Fleet extends DropdownModel {
  @Expose() id: number;
  @Expose() uuid: string;
  @Expose() code: number;
  @Expose() name: string;
  @Expose() email: string;
  @Expose() mobileNumber: string;
  @Expose() moiNumber?: number;
  @Expose() hasMoiNumber?: boolean;
  @Expose() contactName: string;
  @Expose() contactFirstName: string;
  @Expose() contactLastName: string;
  @Expose() contactMobileNumber: string;
  @Expose() vatNumber: string;
  @Expose() insuranceExpiryDate: number;
  @Expose() commercialNumber: number;
  @Expose() primaryTheme: string;
  @Expose() isDefault: boolean;
  @Expose() speedLimit: number;
  @Expose() fleetConfig?: { allowToSelectAllDriversAndTrucks?: boolean };

  @Type(() => LocationModel)
  @Expose()
  locations: LocationModel[] = [];

  @Expose() status: Status = Status.ACTIVE;
  @Expose() users: User[] = [];

  @Type(() => InsuranceModel)
  @Expose()
  insuranceCompany: InsuranceModel = new InsuranceModel();

  @Type(() => InsuranceModel)
  @Expose()
  insuranceCover: InsuranceModel = new InsuranceModel();

  @Type(() => Media)
  @Expose()
  commercialRegistration: Media = new Media();

  @Type(() => Media)
  @Expose()
  logo: Media = new Media();

  @Type(() => Customer)
  @Expose()
  customers: Customer[] = [];

  @Expose() createdAt: number;
  @Expose() updatedAt: number;
  @Expose() usersCount: number;
  @Expose() shipmentsNumber: number;
  @Expose() tripsCount: number;
  @Expose() activationDate: number;
  @Expose() type: FleetType;
  @Expose() controlCenterMobile?: string;

  @Expose() customerCanAssignDriver?: boolean;
  @Expose() canAssignDrivers?: boolean;
  @Expose() operationCard?: AthrOperationCard;
  @Expose() isVerifiedByAthr?: boolean;
  @Expose() isDaleelEnabled?: boolean;
  @Expose() vendorSource?: VendorSource;
  @Expose() classificationSource?: FleetClassificationSource;

  constructor() {
    super();
  }

  get fullName(): string {
    return this.contactFirstName + ' ' + this.contactLastName;
  }

  get dropDownDisplayName(): string {
    return this.name;
  }

  get dropDownValue(): object {
    return this;
  }
}
